import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

//Fahrzeugverwaltung
const VehicleList = () => import('@/views/vehicles/ListVehicles')
const AreaList = () => import('@/views/vehicleManagement/area/ListAreas')
const DriverList = () => import('@/views/vehicleManagement/driver/ListDrivers')

import EditVehicle from "../views/vehicles/EditVehicle";
import EditDriver from "../views/vehicleManagement/driver/EditDriver";
import CreateDriver from "../views/vehicleManagement/driver/CreateDriver";
import CreateVehicle from "../views/vehicles/CreateVehicle";

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

Vue.use(Router)

function configRoutes() {
  return [
    {
      path: '/',
      redirect: '/vehicles/list',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'vehicles/',
          redirect: '/vehicles/list',
          name: 'Fahrzeugverwaltung',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              path: 'areas',
              name: 'Gebiete',
              component: AreaList,
            },
            {
              path: 'drivers',
              name: 'Fahrer',
              component: DriverList,
            },
            {
              path: 'drivers/edit/:id',
              meta: {
                label: 'Fahrer ändern',
              },
              name: 'changeDriver',
              component: EditDriver,
              props: true
            },
            {
              path: 'drivers/create',
              meta: {
                label: 'Fahrer anlegen',
              },
              name: 'createDriver',
              component: CreateDriver,
            },
            {
              path: 'list',
              name: 'Fahrzeuge',
              component: VehicleList,
            },
            {
              path: 'edit/:id',
              meta: {
                label: 'Fahrzeug ändern',
              },
              name: 'editVehicle',
              component: EditVehicle,
              props: true
            },
            {
              path: 'create',
              meta: {
                label: 'Fahrzeug anlegen',
              },
              name: 'createVehicle',
              component: CreateVehicle,
            },
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Users,
            },
            {
              path: ':id',
              meta: { label: 'User Details'},
              name: 'User',
              component: User,
            },
          ]
        },
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
}

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})
